<template>
    <div>
        <div class="d-flex mt-3 align-items-end">
            <h3 class="mr-1">Min/Max Settings</h3>
            <span class="fs-small dark bold ml-2" v-if="selectedPrincingType">Only available in prices per person</span>
        </div>

        <form novalidate @change="eventActivateUpdateFlag('minMaxRules')">
            <div class="mt-3">
                <div class="form-getSelectedEvent row">
                    <div class="col-sm-12">
                        <div>
                            <div class="py-2">
                                <span class="font-weight-600 pl-2" >Booking</span>
                            </div>

                            <div class="py-2 ml-2">
                                <label  :class="{'color-6':validations.getSelectedEvent.rulesBook.$invalid}">Participants (PAX) rules
                                    <span class="color-6 fs-smaller ml-2" v-if="validations.getSelectedEvent.rulesBook.$invalid">Maximum value must be greater than minimum value</span>
                                </label>
                                <div class="d-flex mt-3 mb-1">
                                    <div class="d-flex align-items-center mr-3">
                                        <input type="number" style="width: 60px;" :disabled="selectedPrincingType"  :class="{'pointer':!disabled, 'notAllowed':selectedPrincingType}" v-model="minimumPaxPerBooking" @input="minBookingUpdate">
                                        <label class="w-100 ml-2">Minimun</label>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <input type="number" style="width: 60px;" :disabled="selectedPrincingType"  :class="{'pointer':!disabled, 'notAllowed':selectedPrincingType}" v-model="maximumPaxPerBooking" @input="maxBookingUpdate">
                                        <label class="w-100 ml-2">Maximum</label>
                                    </div>
                                </div>
                            </div>

                            <div class="py-1 ml-2 radios" >
                                <div v-if="getSelectedEvent.minimumPaxPerBooking > 0 || getSelectedEvent.maximumPaxPerBooking > 0">
                                    <span class="fs-small">If the participants' rules are not fulfilled:</span>
                                    <div class="d-flex justify-content-between mt-2" style="width:60%;">
                                        <radio  v-model="getSelectedEvent.rejectBookingBasedOnMinMax" :value="true" :disabled="selectedPrincingType"  @input="eventActivateUpdateFlag('minMaxRules')">
                                            Block bookings
                                        </radio>
                                        <radio  v-model="getSelectedEvent.rejectBookingBasedOnMinMax" :value="false" :disabled="selectedPrincingType"  @input="eventActivateUpdateFlag('minMaxRules')">
                                            Pending to confirm
                                        </radio >
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mt-2">
                            <div class="py-2">
                                <span class="font-weight-600 pl-2">Event</span>
                            </div>

                            <div class="py-2 ml-2">
                                <label  :class="{'color-6':validations.getSelectedEvent.rulesEvent.$invalid}">Participants (PAX) rules
                                    <span class="color-6 fs-smaller ml-2" v-if="validations.getSelectedEvent.rulesEvent.$invalid">Value must be between minimum and maximum</span>
                                </label>
                                <div class="mt-2 ">
                                    <div class="py-2">
                                        <span class="fs-small">If a minimum PAX per event is set, bookings are pending until this minimum is reached </span>
                                    </div>
                                    <div class="d-flex align-items-center ">
                                        <input type="number" style="width: 60px;" :disabled="selectedPrincingType"  :class="{'pointer':!disabled, 'notAllowed':selectedPrincingType}" v-model="minimumLotation" @input="lotationEventUpdate">
                                        <label class="w-100 ml-2">Minimun</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form> 
    </div>
</template>
  
<script>
    import { mapGetters } from 'vuex'

    import extendedVSelect from '@/extends/vue-select'

    export default {
        data() {
            return {
                disabled:false,
                showError:false
            }
        },
        created() {
            // if we are creating product
            if (!this.getSelectedEvent.minimumPaxPerBooking) { this.$set(this.getSelectedEvent, 'minimumPaxPerBooking', 0)};
            if (!this.getSelectedEvent.maximumPaxPerBooking) {this.$set(this.getSelectedEvent, 'maximumPaxPerBooking', 0)};
            if (!this.getSelectedEvent.minimumLotation) {this.$set(this.getSelectedEvent, 'minimumLotation', 0)};
            if (!this.getSelectedEvent.rejectBookingBasedOnMinMax) {this.$set(this.getSelectedEvent, 'rejectBookingBasedOnMinMax', false)};
        },
        props: {
            validations: {
                type: Object
            }
        },
        computed: {
            ...mapGetters([
                    'getSelectedEvent'
                ]),
            selectedPrincingType() {
                return this.getSelectedEvent.eventGenderPrices[0].genderPriceType == 1;
            },
            minimumPaxPerBooking: {
                get() {
                    return this.getSelectedEvent.minimumPaxPerBooking === 0 ? '' : this.getSelectedEvent.minimumPaxPerBooking;
                },
                set(value) {
                    this.getSelectedEvent.minimumPaxPerBooking = value === '' ? 0 : parseInt(value);
                }
            },
            maximumPaxPerBooking: {
                get() {
                    return this.getSelectedEvent.maximumPaxPerBooking === 0 ? '' : this.getSelectedEvent.maximumPaxPerBooking;
                },
                set(value) {
                    this.getSelectedEvent.maximumPaxPerBooking = value === '' ? 0 : parseInt(value);
                }
            },
            minimumLotation: {
                get() {
                    return this.getSelectedEvent.minimumLotation === 0 ? '' : this.getSelectedEvent.minimumLotation;
                },
                set(value) {
                    this.getSelectedEvent.minimumLotation = value === '' ? 0 : parseInt(value);
                }
            }
        },
        methods: {
            minBookingUpdate(event) {
                this.getSelectedEvent.minimumPaxPerBooking = event.target.value === '' ? 0 : parseInt(event.target.value);
                this.eventActivateUpdateFlag('minMaxRules');
            },
            maxBookingUpdate(event) { 
                this.getSelectedEvent.maximumPaxPerBooking = event.target.value === '' ? 0 : parseInt(event.target.value);
                this.eventActivateUpdateFlag('minMaxRules');
                
            },
            lotationEventUpdate(event) {
                this.getSelectedEvent.minimumLotation = event.target.value === '' ? 0 : parseInt(event.target.value);
                this.eventActivateUpdateFlag('minMaxRules');
            }
        },
        components: {
            vSelect: extendedVSelect
        }
    }
</script>
  
<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';
    
    .scheduleTypeHolder {
        button {
            line-height: normal;
            height: 80px;
            width: 160px;
            margin-right: 0.5rem;
    
            &.selected {
                border-color: $color-1;
                border-width: 2px;
            }
        }
    }
</style>
  


// WEBPACK FOOTER //
// areaRulesPax.vue?df1bc068